import { Box, Text } from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/native'
import { Keyboard } from 'react-native'
import { loginStrings } from '../../../data/static/strings'
import { Routes } from '../../../nav/routes'
import { getString } from '../../../util/languageStrings'
import { testProps, useWindowDimensions } from '../../../util/util'
import { logEvent } from '../../../util/util'
import { styles } from '../styles'

interface Props {
  enteredMobile?: string
  btnLoading: boolean
  onChecked: (isChecked: boolean) => void
  allValues?: any
  isChecked: boolean
  showError?: boolean
  selectedAppLanguage?: any
}

const ForgotPassword = ({ btnLoading, showError, selectedAppLanguage }: Props) => {
  const width = useWindowDimensions()

  const themedStyle = styles(width)

  const { navigate } = useNavigation()
  const handleForgotPwdPress = () => {
    if (!btnLoading) {
      logEvent('btn_press', 'forgot_pwd')
      Keyboard?.dismiss()
      navigate(Routes.FORGOT_PASSWORD, { path: Routes.FORGOT_PASSWORD })
    }
  }

  return (
    <Box
      {...themedStyle.loginExtraItemStyle}
      onPress={handleForgotPwdPress}
      {...testProps('forgot-pwd-button')}
      marginTop={showError ? 5 : -15}
      underlayColor={'TRANSPARENT'}>
      <Text fontFamily={'JioType-Medium'} color={'PRIMARY'} fontSize={14} letterSpacing={-0.07} lineHeight={16}>
        {getString(selectedAppLanguage, 'forgotPassword')}
      </Text>
    </Box>
  )
}

export default ForgotPassword
